import React from "react"
import SignupSplashImage from "./png/signup-splash.png"

const SignupSplash = ({ ...rest }) => <img {...rest} src={SignupSplashImage} alt="Operandio" />

export default SignupSplash

export { SignupSplash }
